var map = {
	"./argentina_flag.png": 1636,
	"./bolivia_flag.svg": 1637,
	"./brazil_flag.svg": 1638,
	"./britain_flag.png": 1639,
	"./colombia_flag.svg": 1640,
	"./deutschland_flag.png": 1641,
	"./ecuador_flag.svg": 1642,
	"./gal_flag.png": 1643,
	"./mexico_flag.svg": 1644,
	"./peru_flag.svg": 1645,
	"./puertorico_flag.svg": 1646,
	"./spain_flag.png": 1647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1635;